export default "__VITE_ASSET__BAi8mhN8__"